// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3XZo9","footer":"Form_footer__OMOaQ"};